module.exports = __webpack_public_path__ + "img/header_background.674666a3.png";